module.exports = __webpack_public_path__ + "img/1.2a78918e.png";